import React from 'react';

export default function NotFound(){
    return (
        <p>404 fejl</p>
    )
}